// extracted by mini-css-extract-plugin
export var compactFilters = "_da-4";
export var detailImage = "_da-1";
export var dropdownContainer = "_da-2";
export var imageContainer = "_da-0";
export var selectedCard = "_da-3";